module.exports = __webpack_public_path__ + "static/MM_Greta_New-on-the-blog-876eb8bb0ae9b1c97b9f45efc2e0bc4a.mp4";